import { render, staticRenderFns } from "./SportSingle.vue?vue&type=template&id=8a099614"
import script from "./SportSingle.vue?vue&type=script&lang=js"
export * from "./SportSingle.vue?vue&type=script&lang=js"
import style0 from "./SportSingle.vue?vue&type=style&index=0&id=8a099614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports